import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import {
  loadStripe,
  Stripe,
  StripeAddressElement,
  StripeAddressElementOptions,
  StripeElements,
} from '@stripe/stripe-js';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { environment } from '../../../../environments/environment';
import { UserShippingAddress } from '../../../models/shopping';
import { AccountApiService } from '../../../services/apis/account-api.service';
import { Button } from '../../common/button/button';

@Component({
  selector: 'app-update-user-shipping-address-dialog',
  imports: [
    MatDialogModule,
    Button,
    MatButtonModule,
    MatSelectModule,
    NzSkeletonModule,
  ],
  templateUrl: './update-user-shipping-address-dialog.html',
  styleUrl: './update-user-shipping-address-dialog.scss',
})
export class UpdateUserShippingAddressDialog implements AfterViewInit {
  loading: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<UpdateUserShippingAddressDialog>,
    private accountApi: AccountApiService,
    @Inject(MAT_DIALOG_DATA) public data?: UserShippingAddress
  ) {}
  stripe: Stripe | null = null;
  stripeElements: StripeElements | null = null;
  stripeAddressElement: StripeAddressElement | null = null;
  @ViewChild('shippingAddress')
  shippingAddressElement!: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.load();
  }
  async load() {
    this.stripe = await loadStripe(environment.stripe.apikey);
    if (!this.stripe) {
      return;
    }

    this.stripeElements = this.stripe!.elements({
      appearance: {
        theme: 'stripe', // 可用的主题还有 'flat', 'night', 'none'
      },
    });
    this.stripeAddressElement = this.stripeElements.create('address', {
      mode: 'shipping',
      allowedCountries: ['US'],
      autocomplete: {
        mode: 'google_maps_api',
        apiKey: environment.google.api.place,
      },
      display: { name: 'split' },
      defaultValues: this.data
        ? {
            firstName: this.data?.fname,
            lastName: this.data?.lname,
            address: {
              line1: this.data?.line1,
              line2: this.data?.line2,
              city: this.data?.city,
              state: this.data?.state,
              country: this.data?.country,
              postal_code: this.data?.postal_code,
            },
          }
        : undefined,
    } as StripeAddressElementOptions);
    this.stripeAddressElement.mount(this.shippingAddressElement.nativeElement);
  }

  close(r: any = null) {
    this.dialogRef.close(r);
  }

  async save() {
    const addr = await this.stripeAddressElement?.getValue();
    if (!addr || !addr.complete) {
      return;
    }
    const values = addr.value;
    try {
      this.loading = true;
      var r: UserShippingAddress;
      if (this.data?.id) {
        r = await this.accountApi.updateUserShippingAddress(
          this.data?.id ?? 0,
          {
            fname: values.firstName ?? '',
            lname: values.lastName ?? '',
            line1: values.address.line1,
            line2: values.address.line2 ?? '',
            city: values.address.city,
            state: values.address.state,
            country: values.address.country,
            postal_code: values.address.postal_code,
          }
        );
      } else {
        r = await this.accountApi.createUserShippingAddress({
          fname: values.firstName ?? '',
          lname: values.lastName ?? '',
          line1: values.address.line1,
          line2: values.address.line2 ?? '',
          city: values.address.city,
          state: values.address.state,
          country: values.address.country,
          postal_code: values.address.postal_code,
        });
      }
      this.close(r);
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  async delete() {
    if (!this.data?.id) {
      return;
    }
    try {
      this.loading = true;
      await this.accountApi.deleteUserShippingAddress(this.data.id);
      this.close(true);
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
